module.exports = __webpack_public_path__ + "dist/assets/img/5.33ba18b8.svg";